import { defineStore } from 'pinia';
import { getMySubscription } from '@/providers/mySubscriptionProvider';
import { useAuthStore } from '@/stores/authStore';

export const usePlanCapabilitiesStore = defineStore('planCapabilities', {

    state: () => ({
        plan: null,
        loaded: false,
        loading: false,
    }),

    getters: {

        modules: (state) => state.plan?.modules ?? [],

        hasModule: (state) => (moduleCode) =>
            (state.plan?.modules ?? []).some((module) => module.module_code === moduleCode),

        moduleVisible: (state) => (moduleCode) => {

            if (useAuthStore().isSuperAdmin) {

                return false;

            }

            const modules = state.plan?.modules ?? [];

            if (!state.loaded || modules.length === 0) {

                return true;

            }

            return modules.some((module) => module.module_code === moduleCode);

        },

        featureVisible: (state) => (attributeKey) => {

            if (useAuthStore().isSuperAdmin) {

                return false;

            }

            const modules = state.plan?.modules ?? [];

            if (!state.loaded || modules.length === 0) {

                return true;

            }

            for (const module of modules) {

                const found = (module.booleans ?? []).find((entry) => entry.attribute_key === attributeKey);

                if (found) {

                    return ['true', '1'].includes(String(found.value).toLowerCase());

                }

            }

            return false;

        },

        hasFeature: (state) => (attributeKey) => {

            for (const module of state.plan?.modules ?? []) {

                const found = (module.booleans ?? []).find((entry) => entry.attribute_key === attributeKey);

                if (found) {

                    return ['true', '1'].includes(String(found.value).toLowerCase());

                }

            }

            return false;

        },

        quotaLimit: (state) => (attributeKey) => {

            for (const module of state.plan?.modules ?? []) {

                const found = (module.quotas ?? []).find((entry) => entry.attribute_key === attributeKey);

                if (found) {

                    return found.value;

                }

            }

            return null;

        },

    },

    actions: {

        async hydrate(force = false) {

            if (this.loading || (this.loaded && !force)) {

                return;

            }

            this.loading = true;

            try {

                const response = await getMySubscription();
                this.plan = response?.data?.data?.plan ?? null;
                this.loaded = true;

            } catch (error) {

                this.plan = null;

            } finally {

                this.loading = false;

            }

        },

        reset() {

            this.plan = null;
            this.loaded = false;

        },

    },

});
